import React from 'react';

const Collections = ({
  products,
  selectedCategory,
  sortOption,
  onSortChange,
  onCategoryChange,
  onAddToCart,
  onViewDetails,
}) => {
  return (
    <section className="productsSection">
      <div className="sectionHeaderRow">
        <div>
          <p className="sectionLabel">Featured Collection</p>
          <h3>
            {selectedCategory === 'All' ? 'All Products' : `${selectedCategory} Collection`}
          </h3>
          <p className="sectionSubtext">
            Clean product cards, category filters, sorting, and detail previews.
          </p>
        </div>

        <div className="toolbar">
          <select value={sortOption} onChange={(event) => onSortChange(event.target.value)}>
            <option value="default">Sort: Featured</option>
            <option value="price-low-high">Price: Low to High</option>
            <option value="price-high-low">Price: High to Low</option>
            <option value="rating-high-low">Rating: High to Low</option>
          </select>
        </div>
      </div>

      <div className="categoryPills">
        {['All', 'Men', 'Women', 'Beauty'].map((category) => (
          <button
            key={category}
            type="button"
            className={selectedCategory === category ? 'categoryPill active' : 'categoryPill'}
            onClick={() => onCategoryChange(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="productGrid">
        {products.map((product) => (
          <article className="productCard" key={product.id}>
            <div className="cardMediaWrap">
              <span className="productBadge">{product.badge}</span>
              <img src={product.image} alt={product.name} className="productImage" />
            </div>

            <div className="productContent">
              <div className="productMeta">
                <span className="productCategory">{product.category}</span>
                <span className="productRating">★ {product.rating}</span>
              </div>
              <h4>{product.name}</h4>
              <p>{product.description}</p>
              <div className="productFooter">
                <strong>₹{product.price}</strong>
                <div className="cardActions">
                  <button type="button" className="secondaryBtn" onClick={() => onViewDetails(product)}>
                    Details
                  </button>
                  <button type="button" className="primaryBtn" onClick={() => onAddToCart(product)}>
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Collections;
